import {jsx as _jsx} from "react/jsx-runtime";import {
  createContext,

  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState
} from 'react'
import {
  applyTheme,
  getStoredThemePreference,
  resolveTheme,
  setStoredThemePreference,

} from '../utils/themePreference'






const ThemeContext = createContext(null)

export const useThemePreference = () => {
  const value = useContext(ThemeContext)
  if (!value) throw new Error('useThemePreference must be used within a ThemeProvider')
  return value
}

export const ThemeProvider = (props) => {
  const {children} = props
  const [preference, setPreferenceState] = useState(getStoredThemePreference)

  const setPreference = useCallback((next) => {
    setStoredThemePreference(next)
    setPreferenceState(next)
  }, [])

  useEffect(() => {
    const query = window.matchMedia('(prefers-color-scheme: dark)')
    const sync = () => applyTheme(resolveTheme(preference, query.matches))
    sync()
    if (preference !== 'system') return
    query.addEventListener('change', sync)
    return () => query.removeEventListener('change', sync)
  }, [preference])

  useEffect(() => {
    const onStorage = () => setPreferenceState(getStoredThemePreference())
    window.addEventListener('storage', onStorage)
    return () => window.removeEventListener('storage', onStorage)
  }, [])

  const value = useMemo(() => ({preference, setPreference}), [preference, setPreference])
  return _jsx(ThemeContext.Provider, { value: value, children: children})
}
